import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "./utils/sentrySetup"; 
import { ThemeProvider, createTheme } from "@mui/material/styles";
import * as Sentry from "@sentry/react";
import "./styles/variables.css";
import "./styles/layoutStyles.css";
import "./styles/buttonStyles.css";

const theme = createTheme({
  // Customize your theme here
});

// Sentry.init({
//   dsn: "",

//   integrations: [
//     Sentry.feedbackIntegration({
//       // Additional SDK configuration goes in here, for example:
//       colorScheme: "system",
//       themeLight: {
//         inputOutlineFocus: "var( --color-brand-dark-green)",
//         submitBackground: "var( --color-brand-dark-green)",
//         submitBackgroundHover: "var( --color-brand-dark-green)",
//         submitBorder: "var( --color-brand-dark-green)",
//       },
//     }),
//   ],
// });

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
